import React, { useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import Conexao from '../../providers/Conexao';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import { useLocation } from 'react-router-dom';


export default function BotaoSelectEmpresa(props) {
    const op = useRef(null);
    const [empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();  // Hook para navegação
    // Configurando o idioma para português
 
    const returnButtonEditaEmpresa = (empresa) => {
        return  Number(props.dataEmpresa.idempresa) !== Number(empresa.idempresa) 
    ?   <Button icon="pi pi-check" onClick={()=>{
            confirmDialog({
                message: 'Tem certeza de mudar a empresa?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () =>{
                    changeEmpresa(empresa)
                     
                },
                reject: () => console.log('Logout cancelado'),
            });
        //changeEmpresa
    }}></Button>
    : null

    };
    
    
    
    
    const getEmpresas = () => {
        setLoading(true);
        Conexao.get('empresasController/getEmpresasByRevenda?idRevenda=' + props.dataEmpresa.idrevenda)
            .then(function (response) {
                if (response.status === 200 && response.data.status === 'OK') {
                    setEmpresas(response.data.payload);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const changeEmpresa = (empresa) =>{
        const temp = {
            ...props.dataEmpresa, 
            idempresa : empresa.idempresa, 
            empresa : empresa.razaosocial,
            cnpj : empresa.cpf_cnpj
        }
        
        sessionStorage.setItem('dataEmpresa', JSON.stringify(temp))
         navigate('/home',{state:{
            ...location.state,
            dataEmpresa : temp, 
            tipoAcesso : 'REVENDA'
         }});

    }

    return (
        <React.Fragment>
            <Button
                icon="pi pi-objects-column"
                               
                title="Teste"
                onClick={(e) => {
                    getEmpresas();
                    op.current.toggle(e);
                }}
            />
            <OverlayPanel ref={op} style={{  minWidth: '500px', borderRadius: '3px',  padding: '10px' }}>
                <div className="p-grid relative">
                    {loading ? (
                        <div className="p-d-flex p-jc-center p-ai-center" style={{ minHeight: '200px' }}>
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                        </div>
                    ) : (
                        <DataTable
                            value={empresas}
                            paginator
                            sortMode="multiple"
                            rows={5} // Definindo o número de itens por página
                            rowsPerPageOptions={[5, 10, 25]} // Opções de páginas
                            responsiveLayout="stack"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            tableStyle={{ minWidth: '50vw' }}
                        >
                            <Column bodyStyle={{ fontSize: '12px' }} headerStyle = {{ fontSize: '12px' }} field="idempresa" header="Código" sortable />
                            <Column bodyStyle={{ fontSize: '12px' }} headerStyle = {{ fontSize: '12px' }} field="razaosocial" header="Razão Social" sortable />
                            <Column bodyStyle={{ fontSize: '12px' }} headerStyle = {{ fontSize: '12px' }} field="cidade" header="Cidade" sortable />
                            <Column bodyStyle={{ fontSize: '12px' }} headerStyle = {{ fontSize: '12px' }} field="estado" header="UF" sortable />
                            <Column headerStyle = {{ fontSize: '12px' }} header='Selecionar' body={(rowData)=>returnButtonEditaEmpresa(rowData)}/>
                        </DataTable>
                    )}
                </div>
            </OverlayPanel>
        </React.Fragment>
    );
}
